import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUIStore = create(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      commandOpen: false,
      density: 'comfortable',
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      setCommandOpen: (v) => set({ commandOpen: v }),
      setDensity: (v) => set({ density: v }),
    }),
    { name: 'redserp-ui' }
  )
);
